/* globals ca */
/**
 * CommunityAnalytics CMS
 *
 * VueX Store
 */
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import { account } from './modules/account';
import { cms } from './modules/cms';
import { media } from './modules/media';
import { capture } from './modules/capture';
import { project } from './modules/project';
import { comments } from './modules/comments';
import { user } from './modules/user';

// namespaced
import { app } from './modules/app';
import { forms } from './modules/forms';

Vue.use(Vuex);

export const store = new Vuex.Store({
    // plugins: [createPersistedState({
    //     paths: ['app', 'cms'],
    // })],

    modules: {
        app,
        account,
        cms,
        media,
        capture,
        project,
        comments,
        user,
        forms,
    },
    /*
     * Root state
     */
    state: {
        appName: 'CommunityAnalytics CMS',
        appUrl: '/',
        apiUrl: '',
        apiToken: '',
        isAuthenticated: false,
        isLoading: false,
        module: '',
        title: '',
        roles: [],
    },
    actions,
    getters,
    mutations,
});
